import MAddMembersDialog from './MAddMembersDialog.vue';

export { MAddMembersDialog };
export default MAddMembersDialog;
